/** Format seconds as "Xh Ym" or "Ym". */
export function formatDuration(seconds: number | null | undefined): string {
  if (!seconds) return '0m';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
}
